import { render, staticRenderFns } from "./dialogRoleExpire.vue?vue&type=template&id=4a63745d&scoped=true"
import script from "./dialogRoleExpire.vue?vue&type=script&lang=js"
export * from "./dialogRoleExpire.vue?vue&type=script&lang=js"
import style0 from "./dialogRoleExpire.vue?vue&type=style&index=0&id=4a63745d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63745d",
  null
  
)

export default component.exports